import { useTranslation } from 'react-i18next';
import Input from 'src/components/FormComponents/Input';
import { EnvelopeIcon, PhoneIcon } from 'src/components/Icons/icons';
import { CONTACT_KINDS, StaffLoginContacts } from './useStaffLoginContacts';

type StaffContactFieldsProps = {
    contacts: StaffLoginContacts;
    disabled?: boolean;
    labels: { email: string; phone: string };
};

/** Email and phone inputs for staff edit forms. Confirmed contacts are read-only. */
export const StaffContactFields = ({
    contacts,
    disabled,
    labels,
}: StaffContactFieldsProps) => {
    const { t } = useTranslation();

    return (
        <>
            {CONTACT_KINDS.map(kind => {
                const isPhone = kind === 'phone';
                const error = contacts.error(kind);
                return (
                    <Input
                        key={kind}
                        className="text-input transition-colors duration-150"
                        type={isPhone ? 'tel' : 'email'}
                        inputMode={isPhone ? 'tel' : 'email'}
                        label={isPhone ? labels.phone : labels.email}
                        leadingIcon={isPhone ? PhoneIcon : EnvelopeIcon}
                        value={contacts.value(kind)}
                        readOnly={contacts.isConfirmed(kind)}
                        disabled={disabled}
                        error={
                            error
                                ? { type: 'server', message: error }
                                : undefined
                        }
                        onChange={event =>
                            contacts.change(kind, event.target.value)
                        }
                    />
                );
            })}
            {contacts.pending && (
                <p className="col-span-full text-sm text-mongooseGray">
                    {t('accountAccess.staffContacts.pendingNote')}{' '}
                    {CONTACT_KINDS.filter(kind =>
                        contacts.hasContact(kind),
                    ).map((kind, index) => (
                        <span key={kind}>
                            {index > 0 && ' · '}
                            <button
                                type="button"
                                className="underline underline-offset-2 text-woodyBrown"
                                disabled={disabled}
                                onClick={() =>
                                    void contacts.sendInvitation(kind)
                                }
                            >
                                {t(
                                    kind === 'phone'
                                        ? 'accountAccess.invitation.sendSms'
                                        : 'accountAccess.invitation.sendEmail',
                                )}
                            </button>
                        </span>
                    ))}
                </p>
            )}
        </>
    );
};
